import { render, staticRenderFns } from "./ChannelReportTable.vue?vue&type=template&id=74750705&"
import script from "./ChannelReportTable.vue?vue&type=script&lang=js&"
export * from "./ChannelReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports